import Modal from './BasicModal/Modal';
import FullPageModal from './FullPageModal/FullPageModal';
import ModalBody from './utils/ModalBody';
import ModalFooter from './utils/ModalFooter';
import ModalHeader from './utils/ModalHeader';

export {
  FullPageModal,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
};
